import { type FC, type ReactNode } from "react";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props {
    children?: ReactNode;
}

export const ScreenSizeError: FC<Props> = ({ children }) => (
    <div className="flex justify-center items-center h-full flex-col sm:flex-row">
        <div className="text-8xl">
            <FontAwesomeLight icon="desktop" />
        </div>
        <div className="ml-4 text-center sm:text-left">
            <h2>Screen Size not Supported</h2>
            {typeof children === "undefined" ? (
                <p>The current screen size is too small for this page</p>
            ) : (
                children
            )}
        </div>
    </div>
);
